import React, { useEffect, useRef } from 'react';

const TradingViewChart = ({ symbol }) => {
  const containerId = 'tv_chart_container';
  const chartRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    const createWidget = () => {
      if (typeof window.TradingView === 'undefined' || !chartRef.current || !symbol) return;

      // Clear previous chart if any
      chartRef.current.innerHTML = '';

      new window.TradingView.widget({
        container_id: containerId,
        symbol: symbol,
        width: '100%',
        height: 500,
        theme: 'dark',
        style: '1',
        locale: 'en',
        toolbar_bg: '#131722',
        enable_publishing: false,
        allow_symbol_change: false,
        autosize: true
      });
    };

    // Load script once globally
    if (!window.TradingView) {
      const script = document.createElement('script');
      script.src = 'https://s3.tradingview.com/tv.js';
      script.async = true;
      script.onload = () => {
        if (isMounted) createWidget();
      };
      document.body.appendChild(script);
    } else {
      createWidget();
    }

    return () => {
      isMounted = false;
      if (chartRef.current) chartRef.current.innerHTML = ''; // cleanup DOM on unmount
    };
  }, [symbol]);

  return (
    <div className="w-full">
      <div
        id={containerId}
        ref={chartRef}
        className="h-[500px] w-full"
      />
      <div className="text-center text-xs text-gray-500 mt-3">
        Charts powered by{' '}
        <a
          href="https://www.tradingview.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-blue-500"
        >
          TradingView
        </a>
      </div>
    </div>
  );
};

export default TradingViewChart;
